import { color } from '@telus-uds/palette-allium'
import styled from 'styled-components'

export const OverflowHidden = styled.div`
  overflow: hidden;
`

export const LogoContainer = styled.div`
  padding-bottom: 1rem;
  max-height: 144px;
  > img {
    max-height: calc(144px - 1rem);
    object-fit: contain;
  }
`

export const ProductColumnContainer = styled.div`
  @media (min-width: 576px) {
    padding-left: 1rem;
  }
`

export const SuperScript = styled.sup`
  top: -0.5em;
  position: relative;
  font-size: 0.875rem;
  padding-left: 0.1em;
  vertical-align: baseline;
`

export const DesktopPriceList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  > :nth-child(2) {
    padding-left: 1rem;
    margin-left: 1rem;
    border-left: 1px solid ${color.greyMystic};
  }
`
// using custom media query 575px as theme.js does not have this breakpoint for mobile
export const MobilePriceList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${color.greyAthens};
  > :nth-child(2) {
    border-left: 1px solid ${color.greyMystic};
  }

  @media (min-width: 768px) {
    width: 100%;
    > :nth-child(2) {
      padding-left: 0.5rem;
      margin-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    > * {
      width: 50%;
      align-items: center;
    }
  }
`

export const StyledAppliedPromoCode = styled.div`
  width: fit-content;
  margin-left: 2px;
  margin-bottom: 8px;
  div > p > span {
    @media (max-width: 576px) {
      margin-left: 18px;
    }
  }
`
export const Spacer = styled.div`
  padding-top: 1.5rem;
`

// using custom media query 767px as theme.js does not have this breakpoint for ipad mini
// using custom media query 575px as theme.js does not have this breakpoint for mobile
export const StyledPriceInfoContainer = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    background-color: ${color.greyAthens};
    padding: 0.5rem;
  }
`
// using custom media query 767px as theme.js does not have this breakpoint for ipad mini
// using custom media query 575px as theme.js does not have this breakpoint for mobile
export const StyledTaxesLabel = styled.div`
  display: flex;
  justify-content: ${({ mobileViewPoints }) => (mobileViewPoints ? 'center' : 'flex-end')};
  margin-top: 4px;

  @media (max-width: 575px) {
    justify-content: center;
  }
`

// from 576px to 767px, align items to start
export const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
